/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import ModalTrigger from '../common/ModalTrigger';
import ProjectSummary from '../common/ProjectSummary';
import './ProjectNameSummaryModal.scss';
function ProjectNameSummaryModal(_ref) {
  var projectName = _ref.projectName,
    workCommitment = _ref.workCommitment,
    _ref$location = _ref.location,
    location = _ref$location === void 0 ? 'default' : _ref$location,
    _ref$areaOfExpertises = _ref.areaOfExpertises,
    areaOfExpertises = _ref$areaOfExpertises === void 0 ? [] : _ref$areaOfExpertises,
    _ref$tags = _ref.tags,
    tags = _ref$tags === void 0 ? [] : _ref$tags,
    _ref$jobTitles = _ref.jobTitles,
    jobTitles = _ref$jobTitles === void 0 ? '' : _ref$jobTitles,
    description = _ref.description,
    responsibilities = _ref.responsibilities,
    duration = _ref.duration,
    workLocation = _ref.workLocation,
    shortOfficeLocation = _ref.shortOfficeLocation,
    _ref$startDate = _ref.startDate,
    startDate = _ref$startDate === void 0 ? null : _ref$startDate,
    _ref$buttonStyles = _ref.buttonStyles,
    buttonStyles = _ref$buttonStyles === void 0 ? null : _ref$buttonStyles;
  return /*#__PURE__*/React.createElement(ModalTrigger, {
    triggerText: projectName,
    triggerType: "link",
    buttonStyles: buttonStyles,
    idKey: "project-details-invoice",
    dialogClassName: "modal-900w"
  }, /*#__PURE__*/React.createElement(ProjectSummary, {
    name: projectName,
    workCommitment: workCommitment,
    location: location,
    areaOfExpertises: areaOfExpertises,
    tags: tags,
    jobTitles: jobTitles,
    description: description,
    responsibilities: responsibilities,
    duration: duration,
    workLocation: workLocation,
    shortOfficeLocation: shortOfficeLocation,
    startDate: startDate
  }));
}
ProjectNameSummaryModal.propTypes = {
  projectName: PropTypes.string.isRequired,
  location: PropTypes.string,
  workCommitment: PropTypes.number.isRequired,
  areaOfExpertises: PropTypes.arrayOf(PropTypes.string),
  tags: PropTypes.arrayOf(PropTypes.string),
  jobTitles: PropTypes.string,
  description: PropTypes.string.isRequired,
  responsibilities: PropTypes.arrayOf(PropTypes.string).isRequired,
  duration: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  workLocation: PropTypes.string.isRequired,
  shortOfficeLocation: PropTypes.string.isRequired,
  startDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  buttonStyles: PropTypes.string
};
export default ProjectNameSummaryModal;